import React from 'react';
import { Route, Routes, Outlet } from "react-router-dom";
import LoginPage from './Login/LoginPage';
import PropertyPage from './Property/PropertyPage';
import AuthProvider from '../../AuthProvider';

/**
 * Every path under /admin except /admin/login requires a manager session.
 * AuthProvider calls POST /api/auth/validateSession (MANAGER-only); without a valid session the API responds 401/403 and the user is sent to login.
 */
const AdminProtectedLayout = () => (
  <AuthProvider>
    <Outlet />
  </AuthProvider>
);

/**
 * AdminPage component handles all admin-related routes under /admin
 *
 * @component
 * @returns {React.Element} The rendered AdminPage component.
 */
const AdminPage = () => {
  return (
    <Routes>
      <Route path="login" element={<LoginPage />} />
      <Route element={<AdminProtectedLayout />}>
        <Route path="*" element={<PropertyPage />} />
      </Route>
    </Routes>
  );
};

export default AdminPage;
